import React, { Fragment, useState } from 'react';

import NoSSR from '../../../context/ssr/no-ssr';
import useIntersect from '../../../hooks/useIntersect';
import t from '../../../labels/labelling-utils';
import { makeClassNames } from '../../../utils/styles';
import ErrorComponent from '../../atoms/error/error';
import { IGliderItem } from '../../atoms/glider-item/glider-item';
import Spacer from '../../atoms/spacer/spacer';
import { IMenuGliderItems, MenuGliderItems } from '../../organisms';
import ReportsHomeTable, { IReportsHomeTable } from '../../organisms/reports-home-table/reports-home-table';
import ErrorBoundary from '../error-boundary/error-boundary';
import Glider from '../../organisms/glider/glider';
// import './match-reports-home.scss';

export interface IMatchReportsHome {
  matchDayList: IReportsHomeTable[];
  gliderItems: IGliderItem[];
}

const classNames = () =>
  makeClassNames({
    gliderWrapper: 'match-reports-home--wrapper',
    matchReportsHome: 'match-reports-home',
    content: 'match-reports-home__content',
  });

const ssrPlaceholder = (props: IMenuGliderItems, cn: ReturnType<typeof classNames>) => {
  return (
    <div className={cn.gliderWrapper}>
      <MenuGliderItems {...props} isSSR />
    </div>
  );
};

const createId = (i: string | number): string => `giornata-${i}`;

const getErrorComponent = () => <ErrorComponent>{t('unavailable.data')}</ErrorComponent>;

const isValidMatchList = (matchDayList: IReportsHomeTable[]) => Boolean(matchDayList && matchDayList.length);

const MatchReportsHome = ({ matchDayList, gliderItems }: IMatchReportsHome) => {
  const cn = classNames();
  const [activeIndex, setActiveIndex] = useState(matchDayList.length - 1);

  const onIntersect = (item: HTMLElement) => {
    setActiveIndex(matchDayList.length - Number(item.dataset.index) - 1);
  };
  useIntersect('[data-intersect]', onIntersect);

  const onSelectedGliderItem = (gliderIndex: number) => {
    if (gliderIndex !== activeIndex) {
      setActiveIndex(gliderIndex);
    }
  };

  const gliderComponentProps: IMenuGliderItems = {
    items: gliderItems,
    activeSlideIndex: activeIndex,
    variant: 'mgv',
    onItemSelectedCallback: onSelectedGliderItem,
  };

  return (
    <div className={cn.matchReportsHome}>
      <ErrorBoundary hasError={!isValidMatchList(matchDayList)} errorComponent={getErrorComponent()}>
        <Fragment>
          <NoSSR placeholder={ssrPlaceholder(gliderComponentProps, cn)}>
            <Glider activeIndex={activeIndex} items={gliderItems} onSelectedGliderItem={onSelectedGliderItem} />
          </NoSSR>
          <Spacer size={30} />
          {matchDayList.map((matchDay: IReportsHomeTable) => {
            const id = createId(matchDay.round);
            return (
              <div id={id} key={id} className={cn.content} data-intersect>
                <ReportsHomeTable {...matchDay} round={`${t('match.reports.home.match.day')} ${matchDay.round}`} />
              </div>
            );
          })}
        </Fragment>
      </ErrorBoundary>
    </div>
  );
};

export default MatchReportsHome;
